export type ConnectionColorSwatchProps = {
  /** `connection.color` — a raw preset hex (e.g. `#EF4444`). */
  color: string;
  className?: string;
};

/**
 * 8px square in the connection's colour: the identity marker on the Query
 * Editor and Table Explorer status bars and in the connection picker's list.
 *
 * Square, not round: the Query Editor status bar already draws a round dot
 * for an open transaction, and the Orange / Amber presets would read as that
 * dot. The hairline ring keeps the pale presets (Yellow, Lime) visible on the
 * light theme. Decorative — the connection name always sits beside it — so it
 * is hidden from assistive tech.
 */
export function ConnectionColorSwatch({ color, className = '' }: ConnectionColorSwatchProps) {
  return (
    <span
      aria-hidden="true"
      data-testid="connection-color-swatch"
      className={`h-2 w-2 shrink-0 rounded-[2px] ring-1 ring-inset ring-foreground/20 ${className}`}
      style={{ backgroundColor: color }}
    />
  );
}
